var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      staticClass: "campaign-list",
      attrs: { tag: "div", name: "campaign-list", appear: "" }
    },
    _vm._l(_vm.campaignList, function(campaign) {
      return _c(
        _vm.getCampaignType(campaign),
        _vm._b(
          {
            key: campaign.slug || campaign.id,
            ref: campaign.id,
            refInFor: true,
            tag: "component",
            staticClass: "item",
            attrs: {
              "data-cy": "campaign-item",
              value: _vm._f("toNumber")(campaign.value),
              banner: campaign,
              "is-result": "",
              campaign: campaign,
              "has-favorite": _vm.hasFavorite,
              "is-cashback":
                !_vm.hideCashback && (campaign.eventData || {}).is_cashback,
              "cashback-value": _vm.getCashbackValue(campaign)
            },
            on: {
              favorite: function($event) {
                return _vm.$emit("favorite", campaign)
              }
            },
            nativeOn: {
              click: function($event) {
                return _vm.click(campaign)
              }
            }
          },
          "component",
          _vm.$attrs,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89e02be6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89e02be6","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CampaignList.vue
// module id = 2122
// module chunks = 1610